/**
 * Where a video is, saying only what the list proves (checked on beta 75ac99283). The list's outline carries only its title
 * and status, and "approved" stays from the moment Build it is pressed to well after the video is finished, so it says
 * nothing alone. The scene count and the last turn's failure come from the server with the list.
 */
interface VideoFacts {
  planJson?: unknown;
  thumbnailUrl?: string | null;
  slideThumbnailUrl?: string | null;
  scenes?: { built: number; total: number } | null;
  lastFailure?: { code: string } | null;
}

const WHY_STOPPED: Record<string, string> = {
  MODEL_KEY_LIMIT: 'model key limit',
  MODEL_KEY_REJECTED: 'model key rejected',
  MODEL_KEY_BALANCE: 'model key out of balance',
};

export function videoStage({ planJson, thumbnailUrl, slideThumbnailUrl, scenes, lastFailure }: VideoFacts): string | null {
  if (lastFailure) {
    const why = WHY_STOPPED[lastFailure.code];
    return why ? `Stopped · ${why}` : 'Stopped';
  }
  if (scenes) {
    if (scenes.built >= scenes.total) return 'Built';
    if (scenes.built > 0) return `${scenes.built} of ${scenes.total} built`;
  } else if (thumbnailUrl || slideThumbnailUrl) {
    return 'Built';
  }
  const status = planJson && typeof planJson === 'object' ? (planJson as { status?: unknown }).status : undefined;
  if (!planJson || status === 'generating') return 'Planning';
  if (status === 'draft') return 'Storyboard';
  return null;
}
